import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getSystemVendorInvoicesByPo = async (poNumber) => {
  try {
    const po = String(poNumber || '').trim();
    const response = await apiClient.get(`/systemVendorInvoiceManagement/invoice/by-po/${po}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
